module.exports = __webpack_public_path__ + "static/media/faf-poster-2017.1ee63ee5.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/FafPoster/faf-poster-2017.png
// module id = 159
// module chunks = 0